import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/providers/AuthProvider';
import {
  LayoutDashboard, Package, BookOpen, Truck,
  Users, Monitor, Settings, IceCream2,
} from 'lucide-react';

interface NavItem {
  to:      string;
  labelKey: string;
  icon:    React.ReactNode;
  adminOnly?: boolean;
}

const navItems: NavItem[] = [
  { to: '/dashboard',   labelKey: 'nav.dashboard',   icon: <LayoutDashboard size={18} /> },
  { to: '/recipes',     labelKey: 'nav.recipes',     icon: <BookOpen size={18} /> },
  { to: '/ingredients', labelKey: 'nav.ingredients', icon: <Package size={18} /> },
  { to: '/suppliers',   labelKey: 'nav.suppliers',   icon: <Truck size={18} /> },
  { to: '/kitchen',     labelKey: 'nav.kitchen',     icon: <Monitor size={18} /> },
  { to: '/users',       labelKey: 'nav.users',       icon: <Users size={18} />, adminOnly: true },
  { to: '/settings',    labelKey: 'nav.settings',    icon: <Settings size={18} />, adminOnly: true },
];

export default function Sidebar() {
  const { t }       = useTranslation();
  const { isAdmin } = useAuth();

  return (
    <aside className="hidden md:flex w-56 flex-col border-r border-border bg-card">
      {/* Logo */}
      <div className="flex h-16 items-center gap-2 border-b border-border px-5">
        <IceCream2 size={22} className="text-primary" />
        <span className="text-lg font-semibold tracking-tight">MyNevada</span>
      </div>

      {/* Nav */}
      <nav className="flex-1 overflow-y-auto py-4 px-3">
        <ul className="space-y-1">
          {navItems.map((item) => {
            if (item.adminOnly && !isAdmin) return null;
            return (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    [
                      'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                      isActive
                        ? 'bg-primary text-primary-foreground'
                        : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground',
                    ].join(' ')
                  }
                >
                  {item.icon}
                  {t(item.labelKey)}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
    </aside>
  );
}
